import { DisplayMarket } from "@silo/types";
import { getAssets, getDisplayCollateralYields } from "@silo/utils";
import { AprDisplayV2 } from "../apr-display-v2";
import { Option, pipe } from "effect";
import { getProtocolConfig } from "@silo/config";

interface AprTableProps {
  market: DisplayMarket;
}

export function AprTable({ market }: AprTableProps): JSX.Element {
  const { protocolKey } = market;

  const assets = getAssets(market);

  const nativeRewardsSymbol = pipe(
    getProtocolConfig(protocolKey),
    (config) => config.nativeRewards,
    Option.fromNullable,
    Option.map((nativeRewards) => nativeRewards.symbol),
    Option.getOrElse(() => "")
  );

  return (
    <div
      className="grid gap-4 justify-items-end"
      style={{ gridTemplateColumns: "4fr 3fr" }}
    >
      <div className="text-xs text-right text-shale-200">Deposit APR</div>

      <div className="text-xs text-right text-shale-200">Borrow APR</div>

      {assets.map((asset, i) => {
        const isBaseAsset = i === 0;

        return (
          <>
            {!isBaseAsset && (
              <div
                className="h-px bg-shale-750 justify-self-stretch"
                style={{
                  gridColumnStart: 1,
                  gridColumnEnd: 3,
                }}
              />
            )}

            <div className="flex items-center justify-between justify-self-stretch">
              <div className="text-xs text-shale-200">{asset.symbol}</div>

              <div className="font-mono text-sm font-medium text-white">
                {getDisplayCollateralYields(asset.depositMode) ? (
                  <AprDisplayV2.MarketCardCollateral
                    asset={asset}
                    nativeRewardsSymbol={nativeRewardsSymbol}
                  />
                ) : (
                  <AprDisplayV2.MarketCardProtected
                    asset={asset}
                    nativeRewardsSymbol={nativeRewardsSymbol}
                  />
                )}
              </div>
            </div>

            <div className="font-mono text-sm font-medium text-white">
              <AprDisplayV2.MarketCardDebt
                asset={asset}
                nativeRewardsSymbol={nativeRewardsSymbol}
              />
            </div>
          </>
        );
      })}
    </div>
  );
}
